import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import React, { useCallback, useMemo } from 'react';
import { I18nContext } from './context';
import { formatNBSP, replaceSlot, replaceSlotHTML } from './utils';
var useI18n = function useI18n(props) {
  var _ref = props || {},
    i18nFromProps = _ref.i18n;
  var _ref2 = React.useContext(I18nContext) || {},
    lang = _ref2.lang,
    langJson = _ref2.langJson;
  var i18n = i18nFromProps || langJson;
  var getValue = useCallback(function (key, defaultValue) {
    var res = defaultValue || key;
    if (typeof i18n[key] !== 'undefined') {
      res = i18n[key];
    }
    res = formatNBSP(res);
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    if (args && args.length) {
      return replaceSlot.apply(void 0, [res].concat(args));
    }
    return res;
  }, [i18n]);

  // html富文本处理
  // 业务上去做XSS过滤
  var getHTML = useCallback(function (key, defaultValue) {
    var res = defaultValue || key;
    if (typeof i18n[key] !== 'undefined') {
      res = i18n[key];
    }
    res = formatNBSP(res);
    for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }
    if (args && args.length) {
      return replaceSlotHTML.apply(void 0, [res].concat(args));
    }
    return res;
  }, [i18n]);
  return useMemo(function () {
    if (!i18n || !Object.keys(i18n).length) {
      return {
        t: getValue,
        tHTML: getHTML,
        langJson: {},
        ready: false,
        lang: lang
      };
    }
    return {
      lang: lang,
      langJson: i18n,
      t: getValue,
      tHTML: getHTML
    };
  }, [getValue, i18n, lang]);
};
export default useI18n;